import { Cancel01Icon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import cn from 'classnames';

import styles from './FloatingBanner.module.scss';

export const FloatingBanner = ({ children, className, status, icon, onClose }) => (
  <div className={cn(styles.root, status && styles[status], className)}>
    {icon && <div className={styles.icon}>{icon}</div>}
    <div className={styles.content}>{children}</div>
    {onClose && (
      <button className={styles.close} onClick={onClose} aria-label="Dismiss">
        <HugeiconsIcon icon={Cancel01Icon} size={16} strokeWidth={1.5} color="currentColor" />
      </button>
    )}
  </div>
);
